// components/match/TeamRow.js
import React from "react";
import NextImage from "../../common/NextImage";
import { Icon } from "../../../utils/generalLiveCenter";

const TeamRow = ({ teamName, teamLogo, isWinner, isLive, sport, baseURL, match, isHome }) => {
    return (
        <span className="player">
            {(sport === "basketball" || sport === "cricket" || sport === "icehockey") && (
                <span className="flag">
                    <NextImage src={teamLogo} height={22} width={22} alt={`${teamName} logo`} />
                </span>
            )}
            <span className={`name ${isWinner ? "bold" : ""}`}>{teamName}</span>

            {isLive && sport === "cricket" && match?.batid === (isHome ? match?.competitors?.htid : match?.competitors?.atid) ? (
                <Icon type="bat" src={`${baseURL}/public/assets/images/Bat1.png`} width={15} height={14} alt="bat" />
            ) : (
                isLive &&
                sport === "cricket" && (
                    <Icon type="ball" src={`${baseURL}/public/assets/images/cricket_Ball.png`} width={14} height={14} alt="ball" />
                )
            )}

            {match?.fts === (isHome ? "1" : "2") && (
                <span className="ball">
                    <NextImage src={`${baseURL}/public/assets/images/tennis_ball.png`} width={17} height={17} alt="ball" />
                </span>
            )}
        </span>
    );
};

export default TeamRow;
